import { useState, useEffect, useCallback, useRef } from "react"
import { useParams } from 'react-router-dom'

import Grid from '@material-ui/core/Grid'
import AddIcon from '@material-ui/icons/AddOutlined'
import CircularProgress from '@material-ui/core/CircularProgress'
import SelectOption from '@base/Inputs/Select'
import DialogRemove from '@base/Dialog/DialogRemove'
import Filters from '@base/Filter'
import ButtonPrimary from '@base/Button'
import TextField from "@base/Inputs/Text";
import Table from '@base/Table'
import Title from '@base/Title'
import Toast from '@base/Toast'
import {
  verifyPagingAndSorting,
  PAGE,
  SIZE,
  ASC,
  TOTAL_ELEMENTS,
  TOTAL_PAGES,
} from '@base/Table/Utils'

import ColaboradorService from "@services/ColaboradorService"
import ProcessoService from '@services/ProcessoService'

import { ProcessoResolver } from "@helpers/ProcessoHelper"
import { removePagingAndSorting } from '@helpers/PaginationHelper'

import ColaboradorDialog from "@pages/Colaboradores/ColaboradorDialog"
import ColaboradorLoteDialog from "@pages/Colaboradores/ColaboradorLoteDialog"
import AtribuirAtividadeDialog from "@pages/Colaboradores/AtribuirAtividadeDialog"
import AtribuirEmpresaDialog from "@pages/Colaboradores/AtribuirEmpresaDialog"
import AssignmentTurnedInOutlinedIcon from '@material-ui/icons/AssignmentTurnedInOutlined';
import BusinessCenterOutlinedIcon from '@material-ui/icons/BusinessCenterOutlined';
import BlockIcon from '@material-ui/icons/Block';
import DoneAllIcon from '@material-ui/icons/DoneAll';

import useEmpresas from "@hooks/enums/useEmpresas";
import useAtividades from '@hooks/enums/useAtividades';

export const ListagemColaboradoresPageView = () => {
  const [loading, setLoading] = useState(true);

  const [idColaborador, setIdColaborador] = useState();

  const [openDialogImportarColaboradoresLote, setOpenDialogImportarColaboradoresLote] = useState(false);
  const [openDialogAdicionarColaborador, setOpenDialogAdicionarColaborador] = useState(false);
  const [openDialogAtribuirAtividade, setOpenDialogAtribuirAtividade] = useState(false);
  const [openDialogAtribuirEmpresa, setOpenDialogAtribuirEmpresa] = useState(false);
  const [openDialogRemove, setOpenDialogRemove] = useState(false);

  const [list, setList] = useState([]);
  const [listagemProcesso, setListagemProcesso] = useState([]);
  
  const listagemAtividade = useAtividades();
  const listagemEmpresas = useEmpresas();

  const [page, setPage] = useState(PAGE);
  const [size, setSize] = useState(SIZE);
  const [defaultOrderBy,] = useState('nome')
  const [sort, setSort] = useState([{ orderBy: defaultOrderBy, order: ASC }])
  const [totalElements, setTotalElements] = useState(TOTAL_ELEMENTS);
  const [totalPages, setTotalPages] = useState(TOTAL_PAGES);

  const [filtroNome, setFiltroNome] = useState("");
  const [filtroEmail, setFiltroEmail] = useState("");
  const [filtroProcesso, setFiltroProcesso] = useState();
  const [filtroAtividade, setFiltroAtividade] = useState("");
  const [filtroEmpresa, setFiltroEmpresa] = useState("");
  const [filtros, setFiltros] = useState([]);
  const [filtroAtivo, setFiltroAtivo] = useState(false);
  const [quantidadeFiltrosAplicados, setQuantidadeFiltrosAplicados] = useState(0);

  const params = useParams();
  let processo = ProcessoResolver(params.processo);

  const toastRef = useRef(null);

  const pageName = 'Gerenciar Colaboradores';

  const aplicarFiltros = useCallback((ativo = false) => {
    let f = [];

    if (filtroNome) f.push({ field: 'nome', value: filtroNome });
    if (filtroEmail) f.push({ field: 'email', value: filtroEmail });
    if (filtroProcesso) f.push({ field: 'processo', value: filtroProcesso });
    if (filtroAtividade) f.push({ field: 'atividade', value: filtroAtividade });
    if (filtroEmpresa) f.push({ field: 'empresa', value: filtroEmpresa });

    setFiltros(f);
    setFiltroAtivo(ativo)
    setQuantidadeFiltrosAplicados(f.length);
  },[filtroNome, filtroEmail, filtroProcesso, filtroAtividade, filtroEmpresa]);

  const contarFiltrosAplicados = () => quantidadeFiltrosAplicados;

  const limparFiltros = () => {
    setSort([{ orderBy: defaultOrderBy, order: ASC }]);
    setPage(PAGE);
    setSize(SIZE);

    setFiltros([]);
    setFiltroAtivo(false);
    setFiltroNome("");
    setFiltroEmail("");
    setFiltroProcesso("");
    setFiltroAtividade("");
    setFiltroEmpresa("");
    setQuantidadeFiltrosAplicados(0);
  }


  const desativarColaborador = (id) => {
    ColaboradorService.desativar(id).then(resultado => {
      carregarDados();
    });
  }
  const ativarColaborador = (id) => {
    ColaboradorService.ativar(id).then(resultado => {
      carregarDados();
    });
  }
  const actions = [
  {
    name: () => "Associar Atividades",
    func: (id) => { setOpenDialogAtribuirAtividade(true); setIdColaborador(id); },
    icon: <AssignmentTurnedInOutlinedIcon />,
    disabled: (id, object) => !object.ativo,
  },
  {
    name: () => "Associar Empresa",
    func: (id) => { setOpenDialogAtribuirEmpresa(true); setIdColaborador(id); },
    icon: <BusinessCenterOutlinedIcon />,
    disabled: (id, object) => !object.ativo,
  }, {
    name: (c,l) => l.ativo ? "Desativar" : "Ativar",
    func: (id,objeto) => objeto.ativo ? desativarColaborador(id) : ativarColaborador(id),
    icon: (c,l) => l.ativo ? <BlockIcon /> : <DoneAllIcon/>,
    disabled: (id, object) => false,
    color: (c,l) => l.ativo ? "secondary" : "primary",
  }]


  const carregaCombos = useCallback(() => {
    if(listagemProcesso.length === 0){
      ProcessoService.listar().then(resposta => {
        setListagemProcesso(resposta.data.content.map(processo => {
          return {
            label : processo.nome,
            value : processo.id
          };
        }));

        ProcessoService.buscarProcessoEmAndamento().then(resultado => {
          setFiltroProcesso(resultado.data.id);
          setFiltroAtivo(true);
        });
      });
    }
  }, [listagemProcesso]);

  const carregarDados = useCallback(() => {
      let f = verifyPagingAndSorting(removePagingAndSorting(filtros), page, size, sort, filtroAtivo);

      if (size !== SIZE) f.push({ field: 'paginacao', value: true });

      setLoading(true);

      ColaboradorService.filtrar(processo.id, f).then(resultado => {
        const { content, number, size, totalElements, totalPages } = resultado.data;
        setList(content);
        setPage(number);
        setSize(size);
        setTotalElements(totalElements);
        setTotalPages(totalPages);
        setLoading(false);
      }).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Realizar Filtros!"));
  },  [processo.id, filtros, filtroAtivo, page, size, sort]);

  const handlePage = page => { setPage(page); setFiltroAtivo(true); };
  const handleRowsPerPage = (size, page) => { setPage(page); setSize(size); setFiltroAtivo(true); };
  const handleSort = (orderBy, order) => {
    if (sort.find(s => s.orderBy === orderBy)) {
      let newSort = sort.filter(s => s.orderBy !== orderBy);
      newSort.splice(sort.indexOf(sort.find(s => s.orderBy === orderBy)), 0, { orderBy: orderBy, order: order })
      setSort([...newSort]);
    } else {
      setSort([...sort.filter(s => s.orderBy !== orderBy), { orderBy: orderBy, order: order }]);
    }
    setFiltroAtivo(true);
  }
  const handleClearSort = (orderBy) => { setFiltroAtivo(true); orderBy ? setSort([...sort.filter(s => s.orderBy !== orderBy)]) : setSort([{ orderBy: defaultOrderBy, order: ASC }]) };
  const handleTotalPages = () => totalPages;
  const handleTotalElements = () => totalElements;

  const submitExcluir = (id, setLoading) => {
    ColaboradorService.excluir(id)
      .then(resultado => {
			  toastRef.current.show("success", "Colaborador removido com sucesso!");
			  carregarDados();
			  setIdColaborador(undefined);
		  })
      .catch((error) => {
        if (error.response.data.mensagens !== undefined) {
          toastRef.current.show("error",  error.response.data.mensagens.map(mensagen => mensagen).join(" ,"));
        } else {
          toastRef.current.show("error",  "Ocorreu um erro ao excluir o colaborador.");
        }
		  })
      .finally(() =>{ setLoading(false);  setOpenDialogRemove(false); });
  };


  useEffect(() => carregaCombos(), [carregaCombos]);
  useEffect(() => aplicarFiltros(), [filtroProcesso, aplicarFiltros])
  useEffect(() => carregarDados(), [carregarDados]);

  const columns = [
    { label: 'id', name: 'id', func: (coluna, linha) => linha.ativo === true ? coluna : <span style={{color:"#ccc"}}>{coluna}</span>, key: true },
    { label: 'Nome', name: 'nome', func: (coluna, linha) => linha.ativo === true ? coluna : <span style={{color:"#ccc"}}>{coluna}</span>, key: false },
    { label: 'Sobrenome', name: 'sobrenome',func: (coluna, linha) => linha.ativo === true ? coluna : <span style={{color:"#ccc"}}>{coluna}</span>, key: false },
    { label: 'E-mail', name: 'email', func: (coluna, linha) => linha.ativo === true ? coluna : <span style={{color:"#ccc"}}>{coluna}</span>, key: false },
    { label: 'Processo', name: 'ultimoProcesso', func: (coluna, linha) => linha.ativo === true ? coluna : <span style={{color:"#ccc"}}>{coluna}</span>, key: false }
  ];

  return (
    <>
      <Toast ref={toastRef} />
      <Title>{pageName}</Title>

      <Filters
        handleFilter={aplicarFiltros}
        handleFilterClear={limparFiltros}
        countFilters={contarFiltrosAplicados}
      >
        <Grid item container spacing={3}>
          <Grid item sm={3} lg={3}>
            <TextField
              label='Nome/Sobrenome'
              value={filtroNome}
              name='filtroNome'
              onChange={(e) => setFiltroNome(e.target.value.trim())} />
          </Grid>
          <Grid item sm={3} lg={3}>
            <TextField
              label='E-mail'
              value={filtroEmail}
              name='filtroEmail'
              onChange={(e) => setFiltroEmail(e.target.value.trim())} />
          </Grid>
          <Grid item sm={3} lg={3}>
            <SelectOption
              label='Processo'
              value={filtroProcesso}
              name='filtroProcesso'
              onChange={(e) => setFiltroProcesso(e.target.value)}
              options={listagemProcesso} />
          </Grid>
          <Grid item sm={3} lg={3}>
            <SelectOption
              label='Atividade'
              value={filtroAtividade}
              name='filtroAtividade'
              onChange={(e) => setFiltroAtividade(e.target.value)}
              options={listagemAtividade.data} />
          </Grid>
          <Grid item sm={3} lg={3}>
            <SelectOption
              label='Empresa'
              value={filtroEmpresa}
              name='filtroEmpresa'
              onChange={(e) => setFiltroEmpresa(e.target.value)}
              options={listagemEmpresas.data} />
          </Grid>
        </Grid>
      </Filters>

      <Table
        columns={columns}
        tableData={list}
        actions={actions}
        page={page}
        handlePage={handlePage}
        handleTotalPages={handleTotalPages}
        handleTotalElements={handleTotalElements}
        rowsPerPage={size}
        handleRowsPerPage={handleRowsPerPage}
        sort={sort}
        handleSort={handleSort}
        handleClearSort={handleClearSort}
        loading={loading} />

      <Grid container spacing={3} >
        <Grid item xs={12} >
          <ButtonPrimary
            onClick={() => { setIdColaborador(undefined); setOpenDialogAdicionarColaborador(true); }}
            name="Cadastrar Colaborador"
            startIcon={loading ? <CircularProgress size={16} /> : <AddIcon />}
            disabled={loading}
          />
        </Grid>
        <Grid item xs={12}>
          <ButtonPrimary
            onClick={() => setOpenDialogImportarColaboradoresLote(true)}
            name="Importar Colaboradores em Lote"
            startIcon={loading ? <CircularProgress size={16} /> : <AddIcon />}
            disabled={loading}
          />
        </Grid>
      </Grid>

      {openDialogAtribuirAtividade &&
        <AtribuirAtividadeDialog
          id={idColaborador}
          processo={processo}
          aberto={openDialogAtribuirAtividade}
          aoFechar={() => {
            setOpenDialogAtribuirAtividade(false);
          }}
          aoSalvar={() => {
            setOpenDialogAtribuirAtividade(false);
            carregarDados();
          }}
        />
      }

      {openDialogAtribuirEmpresa &&
        <AtribuirEmpresaDialog
          id={idColaborador}
          processo={processo}
          aberto={openDialogAtribuirEmpresa}
          aoFechar={() => {
            setOpenDialogAtribuirEmpresa(false);
          }}
          aoSalvar={() => {
            setOpenDialogAtribuirEmpresa(false);
            carregarDados();
          }}
        />
      }

      {openDialogAdicionarColaborador &&
        <ColaboradorDialog
          id={idColaborador}
          processo={processo}
          aberto={openDialogAdicionarColaborador}
          loading={loading}
          handleLoading={setLoading}
          aoFechar={() => {
            setIdColaborador(undefined);
            setOpenDialogAdicionarColaborador(false)
          }}
          aoSalvar={() => {
            setIdColaborador(undefined);
            setOpenDialogAdicionarColaborador(false);
            carregarDados();
          }}
        />
      }

      {openDialogImportarColaboradoresLote &&
        <ColaboradorLoteDialog
          processo={processo}
          aberto={openDialogImportarColaboradoresLote}
          aoFechar={() => {
            setOpenDialogImportarColaboradoresLote(false);
            carregarDados();
          }}
          aoSalvar={() => {
            setOpenDialogImportarColaboradoresLote(false);
            carregarDados();
          }}
        />
      }

      {openDialogRemove &&
        <DialogRemove
          maxWidth={"sm"}
          id={idColaborador}
          text={"Tem certeza que seja excluir este colaborador?"}
          close={() => setOpenDialogRemove(false)}
          open={openDialogRemove}
          title={"Importante"}
          handleConfirm={submitExcluir}
        />
      }
    </>
  );
}

export default ListagemColaboradoresPageView;
